import PropTypes from 'prop-types';
import {Box, Divider, Drawer, CssBaseline } from '@mui/material';
import { SidebarItems } from "./SidebarItems";
import { LogoImage } from "./LogoImage";

const drawerWidth = 240;

export const Sidebar = (props) => {
    
    const {
        routes,
        window,
        mobileOpen,
        handleDrawerClose,
        handleDrawerTransitionEnd
    } = props

    const {
        routesAccesos,
        routesAgenda,
        routesClientes,
        routesManagements,
        routesLegal,
        routesAdministrator,
        routesConfiguraciones,
        routesHerramientas,
        routesGarantias,
        routesImportadora,
        routesCashier,
        routesBancos
    } = routes

    const drawer = (
        <div 
            style={{
                background: '#212120',
                color: '#eeeeed'
            }}
        >
            {/* <Toolbar /> */}
            <LogoImage />
            <Divider />
                
            <SidebarItems title='Accesos' tagPermissions={['86_MODULO_ACCESOS']} items={routesAccesos} icon={'fa-solid fa-lock'}/>
            <SidebarItems title='Agenda' tagPermissions={['91_MODULO_AGENDA']} items={routesAgenda} icon={'fa-solid fa-calendar-days'}/>
            <SidebarItems title='Clientes' tagPermissions={['167_MODULO_CLIENTES']} items={routesClientes} icon={'fa-solid fa-users'}/>
            <SidebarItems title='Gestiones' tagPermissions={['93_MODULO_GESTIONES']} items={routesManagements} icon={'fa-solid fa-file-circle-check'}/>
            <SidebarItems title='Juridico' tagPermissions={['111_MODULO_JURIDICO']} items={routesLegal} icon={'fa-solid fa-gavel'} />
            <SidebarItems title='Administrador' tagPermissions={['127_MÓDULO_ADMINISTRADOR']} items={routesAdministrator} icon={'fa-solid fa-briefcase'} />
            <SidebarItems title='Importadora' tagPermissions={['145_MODULO_IMPORTADORA']} items={routesImportadora} icon={'nc-icon nc-delivery-fast'} />
            <SidebarItems title='Garantias' tagPermissions={['GARANTIAS', 'ADMIN']} items={routesGarantias} icon={'nc-icon nc-single-copy-04'} />
            <SidebarItems title='Configuraciones' tagPermissions={['152_MODULO_CONFIGURACIONES']} items={routesConfiguraciones} icon={'fa-solid fa-gears'} />
            <SidebarItems title='Herramientas' tagPermissions={['157_MODULO_HERRAMIENTAS']} items={routesHerramientas} icon={'fa-solid fa-screwdriver-wrench'} />
            <SidebarItems title='Caja' tagPermissions={['162_MODULO_CAJAS']} items={routesCashier} icon={'fa-solid fa-wallet'} />
            <SidebarItems title='Bancos' tagPermissions={['241_MODULO_BANCOS']} items={routesBancos} icon={'fa-solid fa-building-columns'} />

            <Divider />
        </div>
    );

    // Remove this const when copying and pasting into your project.
    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onTransitionEnd={handleDrawerTransitionEnd}
                    onClose={handleDrawerClose}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
        </Box>
    );
}

Sidebar.propTypes = {
    window: PropTypes.func,
};

